import React, {Component} from 'react';
import { observable, action, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { ColorRing } from 'react-loader-spinner';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import { toast } from 'react-toastify';
import {
  Button, ButtonGroup,
  Card,
  Modal, ModalBody, ModalHeader,
  FormInput, FormSelect, FormTextarea, FormCheckbox,
  InputGroup, InputGroupAddon,
  Badge,
} from "shards-react";
import moment from "moment";

const TOPIC_OPTIONS = [
  { value: 'update_notice', label: '업데이트 공지' },
  { value: 'service_notice', label: '서비스 공지' },
  { value: 'event', label: '이벤트 알림' },
  { value: 'payment_notice', label: '결제 안내' },
  { value: 'custom', label: '기타' },
];

const TARGET_OPTIONS = [
  { value: 'all', label: '전체 스토어' },
  { value: 'paid', label: '유료 스토어' },
  { value: 'free', label: '무료 스토어' },
  { value: 'test', label: '테스트(from2d)' },
];

const SCHEDULE_TYPE_OPTIONS = [
  { value: 'once', label: '1회 발송' },
  { value: 'daily', label: '매일' },
  { value: 'weekly', label: '매주' },
  { value: 'monthly', label: '매월' },
];

const STATUS_BADGE = {
  draft: { label: '임시저장', theme: 'secondary' },
  active: { label: '활성', theme: 'success' },
  paused: { label: '중지', theme: 'warning' },
};

@inject(({ AOA }) => ({
  getNotificationTemplateList: AOA.getNotificationTemplateList,
  getNotificationHistoryList: AOA.getNotificationHistoryList,
  saveNotificationTemplate: AOA.saveNotificationTemplate,
  deleteNotificationTemplate: AOA.deleteNotificationTemplate,
  sendNotification: AOA.sendNotification,
  getKakaoTemplateInfo: AOA.getKakaoTemplateInfo,
  getAligoProfileList: AOA.getAligoProfileList,
}))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))

@observer
class NotificationSend extends Component {

  @observable isLoading = true;
  @observable list = {};
  @observable listParams = { page: 1, limit: 20, searchParams: {} };

  // 모달
  @observable isModalOpen = false;
  @observable isSending = false;
  @observable editMode = 'create'; // create, edit
  @observable activeTab = 'basic'; // basic, email, kakao, sms, schedule

  // 템플릿 폼 데이터
  @observable form = this.getEmptyForm();

  // 발송 내역 (하단 콘솔)
  @observable historyList = {};
  @observable isConsoleOpen = true;
  @observable consoleFilter = null; // null=전체, template_id
  @observable expandedHistoryId = null; // 에러 상세 펼침
  @observable kakaoTemplateLoading = false;
  @observable kakaoTemplateData = null; // 조회된 카카오 템플릿 정보
  @observable kakaoVarMapping = {}; // 변수명 매핑 {변수명: 값필드}

  // 등록된 카카오 채널 목록 (알리고 /profile/list/)
  SENDERKEY_FIXED = 'ec6f089c22036d90a23abd5fa8cd362639ba9b78';
  SENDERKEY_FIXED_ALIAS = '@onreple';
  @observable channels = [];
  @observable channelsLoading = false;
  @observable channelsError = '';
  // 채널 리스트 필터 — 기본은 차단(S)만 노출, 전체보기 토글 가능
  @observable showAllChannels = false;

  // 발송 채널 선택
  @observable sendChannels = { email: true, kakao: false, sms: false };

  getEmptyForm() {
    return {
      topic: 'update_notice',
      topicLabel: '업데이트 공지',
      title: '',
      email: { enabled: false, subject: '', content: '' },
      kakao: { enabled: false, senderKey: '', templateCode: '', content: '', buttons: null },
      sms: { enabled: false, content: '', sender: '' },
      targetFilter: 'all',
      schedule: { enabled: false, type: 'once', sendDate: '', sendTime: '10:00', dayOfWeek: 1, dayOfMonth: 1 },
      status: 'draft',
    };
  }

  componentDidMount() {
    this.getList();
    this.loadHistory();
    this.loadChannels();
  }

  @action loadChannels = async () => {
    this.channelsLoading = true;
    this.channelsError = '';
    try {
      const res = await this.props.getAligoProfileList();
      if (res && (res.list || res.code === 0)) {
        this.channels = res.list || [];
        if (res.code !== undefined && res.code !== 0 && (!res.list || res.list.length === 0)) {
          this.channelsError = res.message || '채널 목록 조회 실패';
        }
      } else if (res && res.message) {
        this.channelsError = res.message;
        this.channels = [];
      } else {
        this.channelsError = '채널 목록 응답이 비어 있습니다.';
        this.channels = [];
      }
    } catch (e) {
      this.channelsError = '채널 목록 조회 중 오류가 발생했습니다.';
      this.channels = [];
    }
    this.channelsLoading = false;
  };

  @action getList = async () => {
    this.isLoading = true;
    let res = await this.props.getNotificationTemplateList(this.listParams);
    if (res) this.list = res;
    this.isLoading = false;
  };

  @action openCreateModal = () => {
    this.form = this.getEmptyForm();
    this.editMode = 'create';
    this.activeTab = 'basic';
    this.kakaoTemplateData = null;
    this.kakaoVarMapping = {};
    this.isModalOpen = true;
  };

  @action openEditModal = (item) => {
    this.form = {
      _id: item._id,
      topic: item.topic || 'update_notice',
      topicLabel: item.topicLabel || '',
      title: item.title || '',
      email: item.email || { enabled: false, subject: '', content: '' },
      kakao: item.kakao || { enabled: false, senderKey: '', templateCode: '', content: '', buttons: null },
      sms: item.sms || { enabled: false, content: '', sender: '' },
      targetFilter: item.targetFilter || 'all',
      schedule: item.schedule || { enabled: false, type: 'once', sendDate: '', sendTime: '10:00', dayOfWeek: 1, dayOfMonth: 1 },
      status: item.status || 'draft',
    };
    this.editMode = 'edit';
    this.activeTab = 'basic';
    this.kakaoTemplateData = null;
    this.kakaoVarMapping = {};
    // 기존 카카오 내용에서 변수 추출
    if (this.form.kakao && this.form.kakao.content) {
      var varRegex = /#\{([^}]+)\}/g;
      var match;
      var vars = {};
      while ((match = varRegex.exec(this.form.kakao.content)) !== null) {
        vars[match[1]] = '';
      }
      this.kakaoVarMapping = vars;
    }
    this.isModalOpen = true;
  };

  @action saveTemplate = async () => {
    if (!this.form.title) { toast.error('제목을 입력해주세요.'); return; }

    let topicOpt = TOPIC_OPTIONS.find(o => o.value === this.form.topic);
    let data = {
      ...toJS(this.form),
      topicLabel: topicOpt ? topicOpt.label : this.form.topic,
    };
    delete data._id;
    // 카카오 변수 매핑 저장
    if (data.kakao && Object.keys(toJS(this.kakaoVarMapping)).length > 0) {
      data.kakao.varMapping = toJS(this.kakaoVarMapping);
    }

    let params = { data };
    if (this.editMode === 'edit' && this.form._id) params.id = this.form._id;

    let res = await this.props.saveNotificationTemplate(params);
    if (res && res.data) {
      toast.success(this.editMode === 'create' ? '템플릿이 생성되었습니다.' : '템플릿이 수정되었습니다.');
      this.isModalOpen = false;
      this.getList();
    } else {
      toast.error('저장에 실패했습니다.');
    }
  };

  @action deleteTemplate = async (id) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    let res = await this.props.deleteNotificationTemplate({ id });
    if (res) {
      toast.success('삭제되었습니다.');
      this.getList();
    }
  };

  @action doSend = async (item, isTest) => {
    this.form = { ...item };
    this.sendChannels = {
      email: !!(item.email && item.email.enabled),
      kakao: !!(item.kakao && item.kakao.enabled),
      sms: !!(item.sms && item.sms.enabled),
    };

    let enabledChannels = Object.keys(this.sendChannels).filter(k => this.sendChannels[k]);
    if (enabledChannels.length === 0) {
      toast.error('활성화된 발송 채널이 없습니다. 템플릿을 수정해주세요.');
      return;
    }

    let targetOpt = TARGET_OPTIONS.find(o => o.value === item.targetFilter);
    let targetLabel = targetOpt ? targetOpt.label : '전체';
    let channelLabels = enabledChannels.map(c => c === 'email' ? '이메일' : c === 'kakao' ? '카카오 알림톡' : '문자').join(', ');

    let confirmMsg = isTest
      ? '[테스트 발송]\n\n대상: from2d 스토어\n채널: ' + channelLabels + '\n\n테스트 발송하시겠습니까?'
      : '[' + item.title + ']\n\n대상: ' + targetLabel + '\n채널: ' + channelLabels + '\n\n발송하시겠습니까?';

    if (!window.confirm(confirmMsg)) return;

    this.isSending = true;
    let res = await this.props.sendNotification({
      template_id: item._id,
      channels: enabledChannels,
      isTest: !!isTest,
    });
    this.isSending = false;

    if (res && res.data) {
      let prefix = isTest ? '[테스트] 발송 완료' : '발송 완료';
      let summary = [];
      if (res.data.email) summary.push('이메일: ' + res.data.email.success + '/' + res.data.email.total + ' 성공');
      if (res.data.kakao) summary.push('카카오: ' + res.data.kakao.success + '/' + res.data.kakao.total + ' 성공');
      if (res.data.sms) summary.push('문자: ' + res.data.sms.success + '/' + res.data.sms.total + ' 성공');
      toast.success(prefix + '\n' + summary.join('\n'));
      this.getList();
      this.loadHistory();
    } else {
      toast.error('발송에 실패했습니다.');
    }
  };

  @action fetchKakaoTemplate = async () => {
    let senderKey = this.form.kakao.senderKey;
    let templateCode = this.form.kakao.templateCode;
    if (!senderKey || !templateCode) {
      toast.error('발신프로필 키와 템플릿 코드를 입력해주세요.');
      return;
    }
    this.kakaoTemplateLoading = true;
    this.kakaoTemplateData = null;
    try {
      let res = await this.props.getKakaoTemplateInfo({ senderKey: senderKey, templateCode: templateCode });
      if (res) {
        this.kakaoTemplateData = res;
        // 템플릿 내용에서 변수 추출 (#{변수명} 패턴)
        let content = res.templateContent || '';
        let varRegex = /#\{([^}]+)\}/g;
        let match;
        let vars = {};
        while ((match = varRegex.exec(content)) !== null) {
          vars[match[1]] = this.kakaoVarMapping[match[1]] || '';
        }
        this.kakaoVarMapping = vars;
        // 템플릿 내용을 form에 반영
        this.form.kakao.content = content;
        if (res.buttons) {
          this.form.kakao.buttons = res.buttons;
        }
        toast.success('템플릿 조회 완료: ' + (res.templateName || templateCode));
      } else {
        toast.error('템플릿 조회에 실패했습니다.');
      }
    } catch (e) {
      toast.error('템플릿 조회 오류: ' + (e.message || ''));
    }
    this.kakaoTemplateLoading = false;
  };

  @action onVarMappingChange = (varName, value) => {
    this.kakaoVarMapping[varName] = value;
  };

  @action loadHistory = async (templateId) => {
    let params = { page: 1, limit: 50 };
    if (templateId) params.template_id = templateId;
    let res = await this.props.getNotificationHistoryList(params);
    if (res) this.historyList = res;
    this.consoleFilter = templateId || null;
  };

  @action onFormChange = (field, value) => {
    let keys = field.split('.');
    if (keys.length === 2) {
      this.form[keys[0]][keys[1]] = value;
    } else {
      this.form[field] = value;
    }
  };

  @action goPage = (page) => {
    this.listParams.page = page;
    this.getList();
  };

  renderTabButton = (tab, label, icon) => {
    return (
      <Button
        size="sm"
        theme={this.activeTab === tab ? 'primary' : 'light'}
        onClick={() => this.activeTab = tab}
        style={{fontSize: '12px', padding: '6px 14px'}}
      >
        <span className="material-icons" style={{fontSize: '14px', verticalAlign: 'middle', marginRight: '4px'}}>{icon}</span>
        {label}
      </Button>
    );
  };

  render() {
    const docs = this.list.docs || [];

    return (
      <div style={{padding: '0px 16px 300px'}}>
        <PageTitle title="알림 발송" subtitle="스토어 관리" className="mb-4"/>

        {/* 상단 액션바 */}
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
          <span style={{fontSize: '13px', color: '#495057'}}>
            총 <strong style={{color: '#5664D2'}}>{this.list.totalDocs || 0}</strong>개 알림 템플릿
          </span>
          <div style={{display: 'flex', gap: '8px'}}>
            <Button theme="primary" size="sm" onClick={this.openCreateModal}>
              <FeatherIcon icon="plus" size="14" style={{marginRight: '4px'}}/>
              새 알림 만들기
            </Button>
            <Button theme="info" size="sm" onClick={() => this.props.history && this.props.history.push('/notificationKakaoTemplate')}>
              <FeatherIcon icon="message-square" size="14" style={{marginRight: '4px'}}/>
              새 알림톡 템플릿 만들기
            </Button>
          </div>
        </div>

        {this.isLoading ? (
          <div className="text-center" style={{padding: '60px 0'}}>
            <ColorRing visible={true} height="50" width="50" colors={['#5a6169','#5a6169','#5a6169','#5a6169','#5a6169']}/>
          </div>
        ) : (
          <>
            {/* 템플릿 리스트 */}
            <Card small>
              <div style={{overflowX: 'auto'}}>
                <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '13px'}}>
                  <thead>
                    <tr style={{backgroundColor: '#f8f9fc', borderBottom: '2px solid #e9ecef'}}>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600'}}>상태</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600'}}>주제</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600'}}>제목</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600'}}>채널</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600'}}>대상</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600'}}>스케줄</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600'}}>발송횟수</th>
                      <th style={{padding: '10px 12px', textAlign: 'left', color: '#6c757d', fontWeight: '600'}}>최근발송</th>
                      <th style={{padding: '10px 12px', textAlign: 'center', color: '#6c757d', fontWeight: '600'}}>기능</th>
                    </tr>
                  </thead>
                  <tbody>
                    {docs.length === 0 ? (
                      <tr><td colSpan={9} style={{textAlign: 'center', padding: '40px', color: '#adb5bd'}}>등록된 알림 템플릿이 없습니다.</td></tr>
                    ) : docs.map((item, idx) => {
                      let statusInfo = STATUS_BADGE[item.status] || STATUS_BADGE.draft;
                      let channels = [];
                      if (item.email && item.email.enabled) channels.push('이메일');
                      if (item.kakao && item.kakao.enabled) channels.push('카카오');
                      if (item.sms && item.sms.enabled) channels.push('문자');
                      let tOpt = TARGET_OPTIONS.find(o => o.value === item.targetFilter);
                      let targetLabel = tOpt ? tOpt.label : '전체';
                      let scheduleLabel = (item.schedule && item.schedule.enabled)
                        ? (function(){ var sOpt = SCHEDULE_TYPE_OPTIONS.find(o => o.value === item.schedule.type); return sOpt ? sOpt.label : '-'; })()
                        : '수동';

                      return (
                        <tr key={item._id} style={{borderBottom: '1px solid #f0f0f0', backgroundColor: idx % 2 === 0 ? '#fff' : '#fafbfc'}}>
                          <td style={{padding: '10px 12px'}}>
                            <Badge theme={statusInfo.theme} style={{fontSize: '11px'}}>{statusInfo.label}</Badge>
                          </td>
                          <td style={{padding: '10px 12px', color: '#6c757d'}}>{item.topicLabel || item.topic}</td>
                          <td style={{padding: '10px 12px', fontWeight: '500', color: '#333'}}>{item.title}</td>
                          <td style={{padding: '10px 12px', textAlign: 'center', fontSize: '12px'}}>
                            {channels.length > 0 ? channels.map(c => (
                              <span key={c} style={{display: 'inline-block', padding: '2px 6px', margin: '1px', borderRadius: '8px', backgroundColor: '#eef2ff', color: '#5664D2', fontSize: '11px'}}>{c}</span>
                            )) : <span style={{color: '#adb5bd'}}>-</span>}
                          </td>
                          <td style={{padding: '10px 12px', textAlign: 'center', fontSize: '12px', color: '#6c757d'}}>{targetLabel}</td>
                          <td style={{padding: '10px 12px', textAlign: 'center', fontSize: '12px', color: '#6c757d'}}>{scheduleLabel}</td>
                          <td style={{padding: '10px 12px', textAlign: 'center'}}>
                            <span
                              style={{color: '#5664D2', fontWeight: '600', cursor: 'pointer', textDecoration: 'underline'}}
                              onClick={() => { this.loadHistory(item._id); this.isConsoleOpen = true; }}
                            >{item.sendCount || 0}</span>
                          </td>
                          <td style={{padding: '10px 12px', color: '#adb5bd', whiteSpace: 'nowrap', fontSize: '12px'}}>{item.lastSentAt ? moment(item.lastSentAt).format('MM-DD HH:mm') : '-'}</td>
                          <td style={{padding: '10px 12px', textAlign: 'center', whiteSpace: 'nowrap'}}>
                            <ButtonGroup size="sm">
                              <Button theme="info" style={{fontSize: '11px', padding: '3px 8px'}} disabled={this.isSending} onClick={() => this.doSend(item, true)}>테스트</Button>
                              <Button theme="light" style={{fontSize: '11px', padding: '3px 8px'}} onClick={() => this.openEditModal(item)}>수정</Button>
                              <Button theme="success" style={{fontSize: '11px', padding: '3px 8px'}} disabled={this.isSending} onClick={() => this.doSend(item, false)}>발송</Button>
                              <Button theme="danger" style={{fontSize: '11px', padding: '3px 8px'}} onClick={() => this.deleteTemplate(item._id)}>삭제</Button>
                            </ButtonGroup>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Card>

            {/* 페이지네이션 */}
            {this.list.totalPages > 1 && (
              <div style={{display: 'flex', justifyContent: 'center', gap: '4px', marginTop: '16px'}}>
                <Button size="sm" theme="light" disabled={!this.list.hasPrevPage} onClick={() => this.goPage(this.list.page - 1)}><FeatherIcon icon="chevron-left" size="14"/></Button>
                <span style={{padding: '6px 12px', fontSize: '13px', color: '#6c757d'}}>{this.list.page} / {this.list.totalPages}</span>
                <Button size="sm" theme="light" disabled={!this.list.hasNextPage} onClick={() => this.goPage(this.list.page + 1)}><FeatherIcon icon="chevron-right" size="14"/></Button>
              </div>
            )}
          </>
        )}

        {/* ===== 등록된 카카오 채널 리스트 (알리고 /profile/list/) ===== */}
        {/* 기본: 차단(S) 채널만 노출, [전체보기] 토글로 모든 채널 표시 */}
        {(() => {
          const blockedChannels = this.channels.filter(ch => (ch.status + '').toUpperCase() === 'S');
          const displayed = this.showAllChannels ? this.channels : blockedChannels;
          return (
        <Card small style={{padding: '16px 18px', marginTop: '16px'}}>
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom: 12}}>
            <div style={{fontSize: 14, fontWeight: 700, color: '#1F2937', display:'flex', alignItems:'center', gap:8}}>
              <FeatherIcon icon="message-circle" size="15"/>
              {this.showAllChannels ? '등록된 카카오 채널' : '차단된 카카오 채널'}
              <span style={{fontSize: 12, fontWeight: 400, color: '#6B7280'}}>
                ({displayed.length}{this.showAllChannels ? '' : ` / 전체 ${this.channels.length}`})
              </span>
            </div>
            <div style={{display:'inline-flex', alignItems:'center', gap:6}}>
              <Button theme="light" size="sm" onClick={this.loadChannels} disabled={this.channelsLoading} style={{padding:'4px 10px', fontSize: 12, display:'inline-flex', alignItems:'center', gap:4}} title="알리고 발신프로필 목록 갱신">
                <FeatherIcon icon="refresh-cw" size="12"/>
                {this.channelsLoading ? '갱신 중…' : '갱신'}
              </Button>
              <Button
                theme={this.showAllChannels ? 'primary' : 'light'}
                size="sm"
                onClick={() => { this.showAllChannels = !this.showAllChannels; }}
                style={{padding:'4px 10px', fontSize: 12, display:'inline-flex', alignItems:'center', gap:4}}
                title={this.showAllChannels ? '차단된 채널만 보기' : '모든 채널 보기'}
              >
                <FeatherIcon icon={this.showAllChannels ? 'filter' : 'list'} size="12"/>
                {this.showAllChannels ? '차단만 보기' : '전체보기'}
              </Button>
            </div>
          </div>
          {this.channelsError ? (
            <div style={{padding:'10px 12px', background:'#FEE2E2', border:'1px solid #FECACA', borderRadius:6, fontSize:12, color:'#991B1B'}}>
              {this.channelsError}
            </div>
          ) : displayed.length === 0 && !this.channelsLoading ? (
            <div style={{padding:'24px 12px', textAlign:'center', fontSize:12, color:'#9CA3AF'}}>
              {this.showAllChannels
                ? '조회된 카카오 채널이 없습니다.'
                : (this.channels.length === 0
                  ? '조회된 카카오 채널이 없습니다.'
                  : '차단된 카카오 채널이 없습니다.')}
            </div>
          ) : (
            <div style={{display:'flex', flexDirection:'column', gap:6}}>
              {displayed.map((ch, i) => {
                // 알리고 응답 필드: senderKey(카멜), uuid(@핸들), name(한글명)
                const sk = ch.senderKey || ch.senderkey;
                const isFixed = sk === this.SENDERKEY_FIXED;
                const displayName = ch.name || '(이름 없음)';
                const handle = ch.uuid || '';
                return (
                  <div key={i} style={{
                    display:'flex', alignItems:'center', gap:10, padding:'10px 12px',
                    background: isFixed ? '#FFFBEB' : '#F9FAFB',
                    border: isFixed ? '1px solid #FDE68A' : '1px solid #F3F4F6',
                    borderRadius:6
                  }}>
                    {/* 이름(uuid) 통합 표시 */}
                    <span style={{
                      display:'inline-flex', alignItems:'center', gap:6,
                      padding:'3px 10px', background:'#FEF3C7', color:'#92400E',
                      borderRadius:4, fontSize:12, fontWeight:700, flexShrink:0, maxWidth:360,
                      overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'
                    }} title={`${displayName}${handle ? `(${handle})` : ''} — ${sk || ''}`}>
                      <FeatherIcon icon="message-circle" size="11"/>
                      <span>{displayName}</span>
                      {handle && (
                        <span style={{fontWeight:500, color:'#B45309', fontSize:11}}>
                          ({handle})
                        </span>
                      )}
                    </span>
                    <code style={{fontSize:11, color:'#9CA3AF', wordBreak:'break-all', fontFamily:'Menlo, Consolas, monospace', flex:1, minWidth:0}} title="senderKey">
                      {sk}
                    </code>
                    {ch.status && (() => {
                      const s = (ch.status + '').toUpperCase();
                      const label = s === 'A' ? '정상' : s === 'S' ? '차단' : s === 'D' ? '삭제' : ch.status;
                      const bg = s === 'A' ? '#D1FAE5' : s === 'S' ? '#FEE2E2' : s === 'D' ? '#F3F4F6' : '#E5E7EB';
                      const color = s === 'A' ? '#065F46' : s === 'S' ? '#991B1B' : s === 'D' ? '#6B7280' : '#374151';
                      return (
                        <span title={`상태 (status): ${ch.status}`} style={{fontSize:10, color, fontWeight:600, padding:'2px 6px', background:bg, borderRadius:3, flexShrink:0}}>
                          {label}
                        </span>
                      );
                    })()}
                    {ch.profileStat && (
                      <span title="카카오채널 상태 (profileStat)" style={{fontSize:10, color:'#1E40AF', fontWeight:600, padding:'2px 6px', background:'#DBEAFE', borderRadius:3, flexShrink:0}}>
                        채널: {ch.profileStat}
                      </span>
                    )}
                    {isFixed && (
                      <span style={{fontSize:10, color:'#92400E', fontWeight:700, padding:'2px 6px', background:'#FCD34D', borderRadius:3, flexShrink:0}}>
                        사용중
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </Card>
          );
        })()}

        {/* ===== 생성/수정 모달 ===== */}
        <Modal open={this.isModalOpen} toggle={() => {}} size="lg">
          <ModalHeader toggle={() => this.isModalOpen = false}>
            {this.editMode === 'create' ? '새 알림 템플릿' : '알림 템플릿 수정'}
          </ModalHeader>
          <ModalBody style={{padding: '20px'}}>
            {/* 탭 네비게이션 */}
            <div style={{display: 'flex', gap: '6px', marginBottom: '20px', flexWrap: 'wrap'}}>
              {this.renderTabButton('basic', '기본 정보', 'info')}
              {this.renderTabButton('email', '이메일', 'email')}
              {this.renderTabButton('kakao', '카카오 알림톡', 'chat')}
              {this.renderTabButton('sms', '문자(SMS)', 'sms')}
              {this.renderTabButton('schedule', '스케줄', 'schedule')}
            </div>

            {/* 기본 정보 탭 */}
            {this.activeTab === 'basic' && (
              <div>
                <div style={{marginBottom: '16px'}}>
                  <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>주제</label>
                  <FormSelect value={this.form.topic} onChange={e => this.onFormChange('topic', e.target.value)}>
                    {TOPIC_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                  </FormSelect>
                </div>
                <div style={{marginBottom: '16px'}}>
                  <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>제목</label>
                  <FormInput value={this.form.title} onChange={e => this.onFormChange('title', e.target.value)} placeholder="알림 제목"/>
                </div>
                <div style={{marginBottom: '16px'}}>
                  <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>발송 대상</label>
                  <FormSelect value={this.form.targetFilter} onChange={e => this.onFormChange('targetFilter', e.target.value)}>
                    {TARGET_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                  </FormSelect>
                </div>
                <div style={{marginBottom: '16px'}}>
                  <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>상태</label>
                  <FormSelect value={this.form.status} onChange={e => this.onFormChange('status', e.target.value)}>
                    <option value="draft">임시저장</option>
                    <option value="active">활성</option>
                    <option value="paused">중지</option>
                  </FormSelect>
                </div>
              </div>
            )}

            {/* 이메일 탭 */}
            {this.activeTab === 'email' && (
              <div>
                <div style={{marginBottom: '16px'}}>
                  <FormCheckbox checked={this.form.email.enabled} onChange={() => this.onFormChange('email.enabled', !this.form.email.enabled)}>이메일 발송 활성화</FormCheckbox>
                </div>
                {this.form.email.enabled && (<>
                  <div style={{marginBottom: '16px'}}>
                    <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>메일 제목</label>
                    <FormInput value={this.form.email.subject} onChange={e => this.onFormChange('email.subject', e.target.value)} placeholder="[온리뷰] 메일 제목"/>
                  </div>
                  <div style={{marginBottom: '16px'}}>
                    <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>메일 내용</label>
                    <FormTextarea value={this.form.email.content} onChange={e => this.onFormChange('email.content', e.target.value)} rows="8" placeholder="HTML 또는 텍스트 내용을 입력하세요"/>
                  </div>
                  <div style={{padding: '10px', backgroundColor: '#f8f9fc', borderRadius: '6px', fontSize: '12px', color: '#6c757d'}}>
                    변수: {'#{storeName}'} = 스토어명, {'#{presidentName}'} = 대표자명
                  </div>
                </>)}
              </div>
            )}

            {/* 카카오 알림톡 탭 */}
            {this.activeTab === 'kakao' && (
              <div>
                <div style={{marginBottom: '16px'}}>
                  <FormCheckbox checked={this.form.kakao.enabled} onChange={() => this.onFormChange('kakao.enabled', !this.form.kakao.enabled)}>카카오 알림톡 발송 활성화</FormCheckbox>
                </div>
                {this.form.kakao.enabled && (<>
                  <div style={{marginBottom: '16px'}}>
                    <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>발신프로필 키 (SenderKey)</label>
                    <FormInput value={this.form.kakao.senderKey} onChange={e => this.onFormChange('kakao.senderKey', e.target.value)} placeholder="알리고 발신프로필 키"/>
                  </div>
                  <div style={{marginBottom: '16px'}}>
                    <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>템플릿 코드</label>
                    <InputGroup>
                      <FormInput value={this.form.kakao.templateCode} onChange={e => this.onFormChange('kakao.templateCode', e.target.value)} placeholder="TXXXXXXXXX"/>
                      <InputGroupAddon type="append">
                        <Button theme="info" disabled={this.kakaoTemplateLoading} onClick={this.fetchKakaoTemplate} style={{fontSize: '12px'}}>
                          {this.kakaoTemplateLoading ? '조회중...' : '템플릿 조회'}
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </div>

                  {/* 템플릿 조회 결과 */}
                  {this.kakaoTemplateData && (
                    <div style={{marginBottom: '16px', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden'}}>
                      {/* 템플릿 정보 헤더 */}
                      <div style={{padding: '12px 16px', backgroundColor: '#fef9c3', borderBottom: '1px solid #e2e8f0'}}>
                        <div style={{fontSize: '13px', fontWeight: '600', color: '#92400e'}}>
                          {this.kakaoTemplateData.templateName}
                          <span style={{marginLeft: '8px', fontSize: '11px', fontWeight: '400', color: '#b45309'}}>({this.kakaoTemplateData.templateCode})</span>
                        </div>
                      </div>

                      {/* 템플릿 메시지 미리보기 */}
                      <div style={{padding: '14px 16px', backgroundColor: '#fffef5'}}>
                        <label style={{fontSize: '12px', fontWeight: '600', color: '#6c757d', marginBottom: '6px', display: 'block'}}>메시지 내용 (읽기전용)</label>
                        <pre style={{
                          margin: 0, padding: '12px', backgroundColor: '#f8f9fc', border: '1px solid #e9ecef',
                          borderRadius: '6px', fontSize: '12px', lineHeight: '1.7', color: '#333',
                          whiteSpace: 'pre-wrap', wordBreak: 'break-all', maxHeight: '200px', overflowY: 'auto',
                        }}>{this.kakaoTemplateData.templateContent}</pre>
                      </div>

                      {/* 변수 매핑 영역 */}
                      {Object.keys(this.kakaoVarMapping).length > 0 && (
                        <div style={{padding: '14px 16px', borderTop: '1px solid #e2e8f0'}}>
                          <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '10px', display: 'block'}}>
                            변수 매핑
                            <span style={{fontSize: '11px', fontWeight: '400', color: '#adb5bd', marginLeft: '8px'}}>
                              템플릿의 {'#{변수}'}에 치환할 데이터 필드를 선택하세요
                            </span>
                          </label>
                          {Object.keys(this.kakaoVarMapping).map((varName) => (
                            <div key={varName} style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px'}}>
                              <div style={{
                                minWidth: '140px', padding: '6px 10px', backgroundColor: '#eef2ff', borderRadius: '6px',
                                fontSize: '12px', fontWeight: '600', color: '#5664D2', fontFamily: 'monospace',
                              }}>
                                {'#{' + varName + '}'}
                              </div>
                              <span style={{color: '#adb5bd', fontSize: '14px'}}>→</span>
                              <FormSelect
                                value={this.kakaoVarMapping[varName] || ''}
                                onChange={e => this.onVarMappingChange(varName, e.target.value)}
                                style={{flex: 1, fontSize: '12px'}}
                              >
                                <option value="">-- 매핑 안함 (직접 입력) --</option>
                                <option value="storeName">스토어명 (store.name)</option>
                                <option value="presidentName">대표자명 (store.presidentName)</option>
                                <option value="email">이메일 (store.email)</option>
                                <option value="tel">연락처 (store.tel)</option>
                                <option value="platformId">PlatformId (store.platformId)</option>
                              </FormSelect>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* 버튼 정보 */}
                      {this.kakaoTemplateData.buttons && (
                        <div style={{padding: '14px 16px', borderTop: '1px solid #e2e8f0', backgroundColor: '#fafbfc'}}>
                          <label style={{fontSize: '12px', fontWeight: '600', color: '#6c757d', marginBottom: '8px', display: 'block'}}>버튼 구성</label>
                          {(Array.isArray(this.kakaoTemplateData.buttons) ? this.kakaoTemplateData.buttons :
                            (this.kakaoTemplateData.buttons.button ? this.kakaoTemplateData.buttons.button : [])
                          ).map(function(btn, bi) {
                            return (
                              <div key={bi} style={{
                                display: 'inline-block', padding: '6px 14px', marginRight: '8px', marginBottom: '4px',
                                backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: '6px', fontSize: '12px',
                              }}>
                                <span style={{fontWeight: '600', color: '#333'}}>{btn.name || btn.linkTypeName || '-'}</span>
                                <span style={{color: '#adb5bd', marginLeft: '6px'}}>({btn.linkType || '-'})</span>
                                {btn.linkMo && <span style={{color: '#5664D2', marginLeft: '6px', fontSize: '11px'}}>{btn.linkMo}</span>}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  {/* 템플릿 미조회 시 직접 입력 */}
                  {!this.kakaoTemplateData && (
                    <div style={{marginBottom: '16px'}}>
                      <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>메시지 내용 (직접 입력)</label>
                      <FormTextarea value={this.form.kakao.content} onChange={e => this.onFormChange('kakao.content', e.target.value)} rows="6" placeholder="템플릿 코드를 입력 후 '템플릿 조회'를 클릭하면 자동으로 채워집니다"/>
                    </div>
                  )}

                  <div style={{padding: '10px', backgroundColor: '#f8f9fc', borderRadius: '6px', fontSize: '12px', color: '#6c757d'}}>
                    기본 변수: {'#{storeName}'} = 스토어명, {'#{presidentName}'} = 대표자명 (발송 시 자동 치환)
                  </div>
                </>)}
              </div>
            )}

            {/* 문자 탭 */}
            {this.activeTab === 'sms' && (
              <div>
                <div style={{marginBottom: '16px'}}>
                  <FormCheckbox checked={this.form.sms.enabled} onChange={() => this.onFormChange('sms.enabled', !this.form.sms.enabled)}>문자 발송 활성화</FormCheckbox>
                </div>
                {this.form.sms.enabled && (<>
                  <div style={{marginBottom: '16px'}}>
                    <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>발신 번호</label>
                    <FormInput value={this.form.sms.sender} onChange={e => this.onFormChange('sms.sender', e.target.value)} placeholder="01012345678"/>
                  </div>
                  <div style={{marginBottom: '16px'}}>
                    <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>문자 내용</label>
                    <FormTextarea value={this.form.sms.content} onChange={e => this.onFormChange('sms.content', e.target.value)} rows="5" placeholder="문자 내용 (90자 이하: SMS, 초과: LMS)"/>
                    <div style={{textAlign: 'right', fontSize: '11px', color: (this.form.sms.content || '').length > 90 ? '#dc2626' : '#adb5bd', marginTop: '4px'}}>
                      {(this.form.sms.content || '').length}자 / {(this.form.sms.content || '').length > 90 ? 'LMS' : 'SMS'}
                    </div>
                  </div>
                  <div style={{padding: '10px', backgroundColor: '#f8f9fc', borderRadius: '6px', fontSize: '12px', color: '#6c757d'}}>
                    변수: {'#{storeName}'} = 스토어명, {'#{presidentName}'} = 대표자명
                  </div>
                </>)}
              </div>
            )}

            {/* 스케줄 탭 */}
            {this.activeTab === 'schedule' && (
              <div>
                <div style={{marginBottom: '16px'}}>
                  <FormCheckbox checked={this.form.schedule.enabled} onChange={() => this.onFormChange('schedule.enabled', !this.form.schedule.enabled)}>스케줄 발송 활성화</FormCheckbox>
                </div>
                {this.form.schedule.enabled && (<>
                  <div style={{marginBottom: '16px'}}>
                    <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>발송 주기</label>
                    <FormSelect value={this.form.schedule.type} onChange={e => this.onFormChange('schedule.type', e.target.value)}>
                      {SCHEDULE_TYPE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </FormSelect>
                  </div>
                  {this.form.schedule.type === 'once' && (
                    <div style={{marginBottom: '16px'}}>
                      <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>발송 날짜</label>
                      <FormInput type="date" value={this.form.schedule.sendDate} onChange={e => this.onFormChange('schedule.sendDate', e.target.value)}/>
                    </div>
                  )}
                  {this.form.schedule.type === 'weekly' && (
                    <div style={{marginBottom: '16px'}}>
                      <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>요일</label>
                      <FormSelect value={this.form.schedule.dayOfWeek} onChange={e => this.onFormChange('schedule.dayOfWeek', parseInt(e.target.value))}>
                        {['일','월','화','수','목','금','토'].map((d, i) => <option key={i} value={i}>{d}요일</option>)}
                      </FormSelect>
                    </div>
                  )}
                  {this.form.schedule.type === 'monthly' && (
                    <div style={{marginBottom: '16px'}}>
                      <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>일</label>
                      <FormSelect value={this.form.schedule.dayOfMonth} onChange={e => this.onFormChange('schedule.dayOfMonth', parseInt(e.target.value))}>
                        {Array.from({length: 28}, (_, i) => <option key={i+1} value={i+1}>{i+1}일</option>)}
                      </FormSelect>
                    </div>
                  )}
                  <div style={{marginBottom: '16px'}}>
                    <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>발송 시간</label>
                    <FormInput type="time" value={this.form.schedule.sendTime} onChange={e => this.onFormChange('schedule.sendTime', e.target.value)}/>
                  </div>
                </>)}
              </div>
            )}

            {/* 저장 버튼 */}
            <div style={{textAlign: 'right', marginTop: '20px', borderTop: '1px solid #e9ecef', paddingTop: '16px'}}>
              <Button theme="light" onClick={() => this.isModalOpen = false} style={{marginRight: '8px'}}>취소</Button>
              <Button theme="primary" onClick={this.saveTemplate}>저장</Button>
            </div>
          </ModalBody>
        </Modal>

        {/* ===== 발송 내역 콘솔 패널 (하단 고정) ===== */}
        <div style={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000,
          backgroundColor: '#1e1e2e', color: '#cdd6f4', fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace",
          boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
          transition: 'height 0.2s ease',
          height: this.isConsoleOpen ? '280px' : '36px',
          display: 'flex', flexDirection: 'column',
        }}>
          {/* 콘솔 헤더 */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '6px 16px', backgroundColor: '#181825', borderBottom: '1px solid #313244',
            cursor: 'pointer', flexShrink: 0, userSelect: 'none',
          }} onClick={() => this.isConsoleOpen = !this.isConsoleOpen}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <span style={{color: '#89b4fa', fontSize: '13px', fontWeight: '700'}}>CONSOLE</span>
              <span style={{fontSize: '11px', color: '#6c7086'}}>발송 내역</span>
              {this.consoleFilter && (
                <span style={{fontSize: '10px', padding: '1px 6px', borderRadius: '4px', backgroundColor: '#313244', color: '#a6adc8', cursor: 'pointer'}}
                  onClick={(e) => { e.stopPropagation(); this.loadHistory(); }}>
                  필터 해제 x
                </span>
              )}
              <span style={{fontSize: '11px', color: '#585b70'}}>({(this.historyList.docs || []).length}건)</span>
            </div>
            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
              <span style={{fontSize: '12px', color: '#585b70', cursor: 'pointer'}} onClick={(e) => { e.stopPropagation(); this.loadHistory(this.consoleFilter); }}>
                <span className="material-icons" style={{fontSize: '14px', verticalAlign: 'middle'}}>refresh</span>
              </span>
              <span style={{fontSize: '16px', color: '#6c7086', lineHeight: '1'}}>{this.isConsoleOpen ? '▼' : '▲'}</span>
            </div>
          </div>

          {/* 콘솔 바디 */}
          {this.isConsoleOpen && (
            <div style={{flex: 1, overflowY: 'auto', padding: '0'}}>
              {(this.historyList.docs || []).length === 0 ? (
                <div style={{padding: '20px', textAlign: 'center', color: '#585b70', fontSize: '12px'}}>발송 내역이 없습니다.</div>
              ) : (this.historyList.docs || []).map((h, i) => {
                var channelColor = h.channel === 'email' ? '#89b4fa' : h.channel === 'kakao' ? '#f9e2af' : '#a6e3a1';
                var channelLabel = h.channel === 'email' ? 'EMAIL' : h.channel === 'kakao' ? 'KAKAO' : 'SMS';
                var statusColor = h.failCount > 0 ? '#f38ba8' : h.status === 'completed' ? '#a6e3a1' : h.status === 'sending' ? '#89b4fa' : '#6c7086';
                var statusLabel = h.failCount > 0 ? 'FAIL' : h.status === 'completed' ? 'OK' : h.status === 'sending' ? 'SENDING' : h.status;
                var targetOpt = TARGET_OPTIONS.find(function(x){ return x.value === h.targetFilter; });
                var targetLabel = targetOpt ? targetOpt.label : '-';
                var templateTitle = (h.template_id && h.template_id.title) ? h.template_id.title : (h.title || '-');
                var time = moment(h.createdAt).format('MM-DD HH:mm:ss');
                var hasErrors = h.errors && ((Array.isArray(h.errors) && h.errors.length > 0) || (!Array.isArray(h.errors) && Object.keys(h.errors).length > 0));
                var isExpanded = this.expandedHistoryId === h._id;
                var errorList = hasErrors ? (Array.isArray(h.errors) ? h.errors : [h.errors]) : [];

                return (
                  <div key={h._id}>
                    <div
                      style={{
                        padding: '4px 16px', fontSize: '12px', lineHeight: '1.8',
                        borderBottom: '1px solid #21212e',
                        backgroundColor: i % 2 === 0 ? 'transparent' : 'rgba(49, 50, 68, 0.3)',
                        cursor: hasErrors ? 'pointer' : 'default',
                      }}
                      onClick={() => { if (hasErrors) this.expandedHistoryId = isExpanded ? null : h._id; }}
                    >
                      {hasErrors && (
                        <span style={{color: '#f38ba8', marginRight: '4px', fontSize: '10px'}}>{isExpanded ? '▼' : '▶'}</span>
                      )}
                      <span style={{color: '#585b70'}}>{time}</span>
                      {'  '}
                      <span style={{color: channelColor, fontWeight: '700'}}>[{channelLabel}]</span>
                      {'  '}
                      <span style={{color: '#cdd6f4'}}>{templateTitle}</span>
                      {'  '}
                      <span style={{color: '#6c7086'}}>target=</span><span style={{color: '#cba6f7'}}>{targetLabel}</span>
                      {'  '}
                      <span style={{color: '#6c7086'}}>total=</span><span style={{color: '#cdd6f4'}}>{h.totalCount}</span>
                      {'  '}
                      <span style={{color: '#6c7086'}}>success=</span><span style={{color: '#a6e3a1'}}>{h.successCount}</span>
                      {'  '}
                      {h.failCount > 0 && (<><span style={{color: '#6c7086'}}>fail=</span><span style={{color: '#f38ba8'}}>{h.failCount}</span>{'  '}</>)}
                      <span style={{color: statusColor, fontWeight: '600'}}>{statusLabel}</span>
                      {hasErrors && !isExpanded && (
                        <span style={{color: '#585b70', marginLeft: '8px', fontSize: '11px'}}>(클릭하여 상세 보기)</span>
                      )}
                    </div>
                    {/* 에러 상세 하위 펼침 */}
                    {isExpanded && errorList.length > 0 && (
                      <div style={{backgroundColor: '#11111b', borderBottom: '1px solid #21212e'}}>
                        <div style={{padding: '6px 16px 4px 32px', fontSize: '11px', color: '#f38ba8', fontWeight: '600', borderBottom: '1px solid #1e1e2e'}}>
                          Error Details ({errorList.length}건)
                        </div>
                        {errorList.map(function(err, ei) {
                          return (
                            <div key={ei} style={{padding: '3px 16px 3px 40px', fontSize: '11px', lineHeight: '1.7', borderBottom: '1px solid #1a1a28'}}>
                              <span style={{color: '#585b70'}}>{ei + 1}.</span>
                              {'  '}
                              <span style={{color: '#cba6f7'}}>{err.store || '-'}</span>
                              {'  '}
                              {err.email && (<><span style={{color: '#6c7086'}}>email=</span><span style={{color: '#89b4fa'}}>{err.email}</span>{'  '}</>)}
                              {err.tel && (<><span style={{color: '#6c7086'}}>tel=</span><span style={{color: '#f9e2af'}}>{err.tel}</span>{'  '}</>)}
                              <span style={{color: '#6c7086'}}>error=</span><span style={{color: '#f38ba8'}}>{err.error || 'Unknown'}</span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* 발송 중 오버레이 */}
        {this.isSending && (
          <div style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <div style={{backgroundColor: '#fff', padding: '40px', borderRadius: '12px', textAlign: 'center'}}>
              <ColorRing visible={true} height="50" width="50" colors={['#5664D2','#5664D2','#5664D2','#5664D2','#5664D2']}/>
              <p style={{marginTop: '16px', fontSize: '15px', fontWeight: '600', color: '#333'}}>알림 발송 중...</p>
              <p style={{fontSize: '13px', color: '#6c757d'}}>잠시만 기다려주세요</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default NotificationSend;
